import { FC } from "react";
import { VoteType } from "../../utils/data";
import { conciseAddress } from "../../utils/formatter";

interface VoterDataProps {
  voterData: Array<VoteType>;
}

const VoteTable: FC<VoterDataProps> = ({ voterData }) => {
  return (
    <table className="table p-4 bg-white shadow rounded-lg w-full">
      <thead>
        <tr>
          <th className="border-b-2 p-4 dark:border-dark-5 whitespace-nowrap font-normal text-gray-900">
            #
          </th>
          <th className="border-b-2 p-4 dark:border-dark-5 whitespace-nowrap font-normal text-gray-900">
            Address
          </th>
          <th className="border-b-2 p-4 dark:border-dark-5 whitespace-nowrap font-normal text-gray-900">
            Number of Votes
          </th>
        </tr>
      </thead>
      <tbody>
        {voterData.map((data) => {
          return (
            <tr className="text-gray-700">
              <td className="border-b-2 p-4 dark:border-dark-5 whitespace-nowrap text-center">
                {data.id}
              </td>
              <td className="border-b-2 p-4 dark:border-dark-5 whitespace-nowrap text-center">
                {conciseAddress(data.address)}
              </td>
              <td className="border-b-2 p-4 dark:border-dark-5 whitespace-nowrap text-center">
                {data.numberOfVotes}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default VoteTable;
